import useClientQuery from "../../../global/queries/useClientQuery";
import {AccordionData} from "../../../global/interfaces/AccordionData";
import {useEffect, useState} from "react";
import {clientFields} from "../../../global/interfaces/Client";


const useFormData = () => {
    const {data: client,} = useClientQuery();

    const companyData: AccordionData[] = [
        {label: "Name", size: 6, value: client?.name1, field: clientFields.name1},
        {label: "Telefon", size: 6, value: client?.telefon1, field: clientFields.telefon1},
        {label: "Name (Zeile 2)", size: 6, value: client?.name2, field: clientFields.name2},
        {label: "E-Mail", size: 6, value: client?.email, field: clientFields.email},
        {label: "Webseite", size: 6, value: client?.web, field: clientFields.web},
        {label: "E-Mail (e-Rechnungen)", size: 6, value: client?.emailERechnung, field: clientFields.emailERechnung},
        {label: "UID-Nummer", size: 6, value: client?.uidnr, field: clientFields.uidnr},
        {label: "Firmenbuchnummer", size: 6, value: client?.firmenbuchnummer, field: clientFields.firmenbuchnummer}
    ]

    const addressData: AccordionData[] = [
        {label: "Straße, Nr.", size: 12, value: client?.strasse, field: clientFields.strasse},
        {label: "Land", size: 3, value: client?.land, field: clientFields.land},
        {label: "PLZ", size: 2, value: client?.plz, field: clientFields.plz},
        {label: "Ort", size: 7, value: client?.ort, field: clientFields.ort},
    ]

    const [companyDataState, setCompanyDataState] = useState<AccordionData[]>([] as AccordionData[]);
    const [addressDataState, setAddressDataState] = useState<AccordionData[]>([] as AccordionData[]);

    useEffect(() => {
        setCompanyDataState(companyData);
        setAddressDataState(addressData);
    }, [client]);

    return { companyDataState, setCompanyDataState, addressDataState, setAddressDataState, companyData, addressData };
}

export default useFormData;